<template>
    <v-data-table
        :headers="tableHeaders"
        :items="listLotesFiltrada"
        :loading="loading"
        item-key="idLoteProducao"
        :calculate-widths="true"
        @click:row="goToLote"
        dense
    >
    </v-data-table>
</template>
<script>
export default {
    name: 'MortalityCausesTable',
    computed:{
        tableHeaders() {
			return [
                {
					text: 'Quantidade',
					value: 'qtBaixas',
          			align: "start"
				},
				{
					text: 'Produtor',
					value: 'nmProdutor',
          			align: "start"
				},
				{
					text: 'UEP',
					value: 'nrUnidadeExploracao',
          			align: "start"
				},
				{
					text: 'Pavilhão',
					value: 'nrPavilhao',
          			align: "start"
				},
                {
					text: 'Lote Controle',
					value: 'nrLoteControle',
          			align: "start"
				},
				{
					text: 'Estabelecimento',
					value: 'nmEstabelecimento',
          			align: "start"
				},
                {
					text: 'Identificador Lote',
					value: 'idLoteProducao',
          			align: "start"
				},
			];
		},
        listLotesFiltrada() {
            if (this.dsMotivoBaixaFilter != '') {
                let context = this;
                let listaFiltrada = []

                this.dataGraph.listLotes.forEach(lote => {
                    let listaBaixasFiltrada = []
                    listaBaixasFiltrada = lote.baixa
                    .filter(x => x.nmMotivoBaixa == context.dsMotivoBaixaFilter);

                    if (listaBaixasFiltrada.length > 0) {
                        let totalBaixas = 0
                        listaBaixasFiltrada.forEach(baixa => {
                            totalBaixas += baixa.qtBaixa
                        });
                        lote.qtBaixas = totalBaixas
                        lote.nmMotivoBaixa = context.dsMotivoBaixaFilter

                        listaFiltrada.push(lote)
                    }
                });
                return listaFiltrada.sort((a, b) => {
                    return b.qtBaixas - a.qtBaixas
                })
            }
            return [];
        }
    },
    methods: {
        goToLote(loteProducao) {
            this.$router.push({name: 'loteProducao', params: {id: loteProducao.idLoteProducao}})
        },
    },
    props: {
        dataGraph: {},
        loading: Boolean,
        dsMotivoBaixaFilter: "",
    }
}
</script>
